import { gql } from '@apollo/client';

export const GET_REGION_CODE = gql`
  query GetRegionCode {
    orgRegionCode
  }
`;
